import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";
import { CSSProperties } from "react";

export const headerStyles: BoxStyleProps & { style?: React.CSSProperties } = {
    style: { background: "rgba(60, 123, 186, 0.87)", textAlign: "center" }, // Custom color via inline style
    padding: "space40",
    borderBottomStyle: "solid",
    borderBottomWidth: "borderWidth10",
    borderBottomColor: "colorBorderWeak",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
};
export const headerWrapperStyles: BoxStyleProps & { style?: React.CSSProperties } = {

    backgroundImage: "url('https://eastprodcdn.azureedge.net/content/images/inline/header-bg-city.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center"
}

export const titleStyles: TextStyleProps & { style?: React.CSSProperties } = {
    style: { color: "#fff", textAlign: "center" },
    fontFamily: "fontFamilyText",
    fontSize: "fontSize30",
    fontWeight: "fontWeightBold",
    margin: "space0"
};

export const logoStyles = {
    style: { marginTop: "10px" },
    width: "350px",
    height: "80px",
} as const;
export const headerButtonStyles: CSSProperties = {
    padding: "8px 10px",
    cursor: "pointer",
    color: '#fff',
    fontSize: '15px',
    fontWeight: '600',
    lineHeight: '1.25rem',
    position: 'absolute',
    right: '2px',
    top: '0px',
    border: 'none',
    backgroundColor: 'rgba(60, 123, 186, 0.1)'
};
